import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { CategoryEntity } from './category.entity';
import { ClientEntity } from './client.entity';

@Index('fk_category__id', ['fkCategoryId'], {})
@Index('fk_client__id', ['fkClientId'], {})
@Entity('client_category')
export class ClientCategoryEntity extends BaseEntity {
	@Column('int', { name: 'fk_client__id', unsigned: true })
	public fkClientId!: number;

	@Column('int', { name: 'fk_category__id', unsigned: true })
	public fkCategoryId!: number;

	@ManyToOne(() => ClientEntity, (client) => client.clientCategories, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_client__id', referencedColumnName: 'id' }])
	public fkClient!: ClientEntity;

	@ManyToOne(() => CategoryEntity, (category) => category.clientCategories, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_category__id', referencedColumnName: 'id' }])
	public fkCategory!: CategoryEntity;
}
